import 'zone.js/dist/zone';
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';

import 'core-js/es6/number';
import 'core-js/es6/array';
import 'core-js/es6/string';

import './main.css'

//import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

 import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

//if (process.env.ENV === 'production') {
    //enableProdMode();
//}
// if (environment.production) {
//     enableProdMode();
// }

platformBrowserDynamic().bootstrapModule(AppModule);


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/